import { Rate } from '~/services/AccommodationService';

enum BundleStatus {
  /** `!packaged && !isFlightBundle` */
  NOT_BUNDLED,
  /** `!packaged && isFlightBundle` */
  MISCONFIGURED,
  /** `packaged && !isFlightBundle` */
  FAUX_NOT_BUNDLED,
  /** `packaged && isFlightBundle` */
  BUNDLED,
}

interface BundleStatusInfo {
  summary: string;
  description: string;
  color: 'error' | 'warning' | 'info';
}

const BUNDLE_STATUS_TO_INFO: Record<BundleStatus, BundleStatusInfo | undefined> = {
  [BundleStatus.NOT_BUNDLED]: undefined,
  [BundleStatus.MISCONFIGURED]: {
    summary: 'No',
    description: 'This rate does not include a flight bundle, but will only be shown on the "Hotels + flights" tab',
    color: 'error',
  },
  [BundleStatus.FAUX_NOT_BUNDLED]: {
    summary: 'Yes',
    description: 'This rate includes a flight bundle, but will also be shown on the "Hotels" tab',
    color: 'warning',
  },
  [BundleStatus.BUNDLED]: {
    summary: 'Yes',
    description: 'This rate includes a flight bundle, and will only be shown on the "Hotels + flights" tab',
    color: 'info',
  },
};

export const getBundleStatusInfo = (meta: Rate['meta']) => {
  const packaged = meta?.packaged ?? false;
  const isFlightBundle = meta?.isFlightBundle ?? false;

  const packagedOffset = packaged ? 2 : 0;
  const isFlightBundleOffset = isFlightBundle ? 1 : 0;
  const bundleStatus: BundleStatus = packagedOffset + isFlightBundleOffset;
  return BUNDLE_STATUS_TO_INFO[bundleStatus];
};

export const getExternalId = (rate: Rate) => {
  if (rate.meta.type === 'bedbank') {
    return rate.meta.bedbankRateId;
  }
  return rate.meta.reservationRoomRateId;
};
